import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Send } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useConfirm } from '../context/ConfirmContext';
import { Sidebar } from '../components/Sidebar';
import type { SidebarNavItem } from '../components/Sidebar';
import { JackpotWidget } from '../components/jackpot/JackpotWidget';

interface AdminLayoutProps {
  children?: React.ReactNode;
}

const NAV_ITEMS: SidebarNavItem[] = [
  { path: '/admin/accounts', label: 'Quản lý tài khoản', icon: Users },
  { path: '/admin/telegram', label: 'Telegram', icon: Send },
];

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const confirm = useConfirm();

  const handleLogout = async () => {
    const isConfirmed = await confirm({
      title: 'Đăng xuất',
      message: 'Bạn có chắc chắn muốn đăng xuất?',
    });
    if (isConfirmed) {
      logout();
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[#0d0f14]">
      <Sidebar
        navItems={NAV_ITEMS}
        logoText="Sunwin"
        logoAccent="Admin"
        userName={user?.username ?? ''}
        userRole={user?.role ?? ''}
        onLogout={() => {
          void handleLogout();
        }}
      />
      <main className="custom-scrollbar flex-1 overflow-y-auto p-6">
        <div className="mx-auto max-w-7xl">{children}</div>
      </main>
      <JackpotWidget />
    </div>
  );
};

export default AdminLayout;
